module.exports = __webpack_public_path__ + "2e8c4bbc60a1a1f641303f72b26b64a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_110.jpg
// module id = 1694
// module chunks = 5